import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", stroke: "#1A1B1E", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 6.5h15M4.5 12h15M4.5 17.5h15" }));
export default SvgMenu;
